import { Navigate, Outlet } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'
import { Loading } from '@/components/ui/loading'

export function AdminRoute() {
  const [loading, setLoading] = useState(true)
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    const verifyAdminRole = async () => {
      try {
        console.log("[AdminRoute] Verificando acesso administrativo...")
        
        // Verificar usuário atual
        const { data: { user }, error: authError } = await supabase.auth.getUser()
        
        if (authError || !user) {
          console.log("[AdminRoute] Usuário não autenticado:", authError?.message)
          setIsAdmin(false)
          return
        }
        
        console.log(`[AdminRoute] Usuário autenticado: ${user.id}`)
        
        // Verificar papel do usuário diretamente no banco
        const { data, error } = await supabase
          .from('users')
          .select('role')
          .eq('id', user.id)
          .single()
        
        if (error) {
          console.error("[AdminRoute] Erro ao verificar papel do usuário:", error)
          setIsAdmin(false)
          return
        }
        
        const hasAdminRole = data?.role === 'admin'
        console.log(`[AdminRoute] Usuário é administrador? ${hasAdminRole}`)
        setIsAdmin(hasAdminRole)
      } catch (error) {
        console.error("[AdminRoute] Erro ao verificar papel administrativo:", error)
        setIsAdmin(false)
      } finally {
        setLoading(false)
      }
    }
    
    verifyAdminRole()
  }, [])
  
  if (loading) {
    return <Loading />
  }
  
  if (!isAdmin) {
    console.log("[AdminRoute] Acesso administrativo negado. Redirecionando para o dashboard.")
    return <Navigate to="/dashboard" replace />
  }
  
  console.log("[AdminRoute] Acesso administrativo permitido.")
  return <Outlet />
} 